<script setup lang="ts">
import { Button } from '@dashhudson/dashing-ui/button';
import { useSidePanel } from '@dashhudson/dashing-ui/side-panel';
import { useRouter } from 'vue-router';

import { VISION_AI_SUMMARY_INTERACTIONS } from '@/components/VisionAi/constants';
import type { RedirectButtonWidgetData } from '@/components/VisionAi/widgets/visionWidget.types';
import { useVisionAiStore } from '@/stores/vision-ai';

const { widgetData } = defineProps<{
  widgetData: RedirectButtonWidgetData;
  narrowMode?: boolean;
}>();

const emit = defineEmits<{
  onWidgetClick: [interaction: string];
}>();

const router = useRouter();
const visionAiStore = useVisionAiStore();
const { setExpanded } = useSidePanel();

function handleClick() {
  emit('onWidgetClick', VISION_AI_SUMMARY_INTERACTIONS.REDIRECT_BUTTON_CLICK);
  const { pathname, search, hash } = new URL(widgetData.url, window.location.origin);
  setExpanded(false);
  visionAiStore.setKeepVisionPanelOpen(true);
  router.push(`${pathname}${search}${hash}`).finally(() => {
    visionAiStore.setKeepVisionPanelOpen(false);
  });
}
</script>

<template>
  <Button
    severity="primary"
    :label="widgetData.label"
    :icon="widgetData.icon"
    data-testid="redirect-button-widget"
    @click="handleClick"
  />
</template>
